import type { ReactNode } from 'react'
import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { PrimaryButton } from 'shared/components/button'
import FormInput from 'shared/components/form-input'
import { BadRequest } from 'shared/errors/bad-request'
import { registerCommunity } from '../api/community-api'

function RegisterForm({
  showThankYou,
  disabled,
}: {
  showThankYou: () => void
  disabled: boolean
  isJoinFlow?: boolean
}): ReactNode {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const router = useRouter()
  const { communityPath, invitationToken, confirmationToken } = router.query

  async function register(): Promise<void> {
    // TODO: rewrite to use TanStack Query
    try {
      setIsLoading(true)
      const params = new URLSearchParams()
      if (invitationToken) {
        params.set('invitationToken', invitationToken)
      }
      if (confirmationToken) {
        params.set('confirmationToken', confirmationToken)
      }
      const paramsStr = params.toString()
      await registerCommunity(
        email,
        `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${globalThis.location.host}/community/${communityPath}${paramsStr ? `?${paramsStr}` : ''}`,
      )
      setIsLoading(false)
      showThankYou()
    } catch (error) {
      setIsLoading(false)
      if (error instanceof BadRequest && error.errors.fields.email) {
        setEmailError(error.errors.fields.email.join('\n'))
      }
    }
  }

  function changeEmail(e: React.ChangeEvent<HTMLInputElement>): void {
    setEmail(e.target.value)
  }

  return (
    <>
      <FormInput
        key="email"
        type="email"
        value={email}
        className="flex-auto"
        label={t('global.email_address')}
        onChange={changeEmail}
        maxLength={180}
        error={emailError}
        disabled={disabled}
      />
      <PrimaryButton key="register" isLoading={isLoading} onClick={register} disabled={disabled}>
        {t('join_form.button.register.title')}
      </PrimaryButton>
    </>
  )
}

export default RegisterForm
